import { Navigate } from "react-router-dom";

import { useAppContext } from "../components/contexts/appContext";

interface AuthRouteProps {
	component: React.FC;
}

export const AuthRoute = ({ component: Component }: AuthRouteProps) => {
	const { isUserLoggedIn } = useAppContext();

	if (isUserLoggedIn) {
		return <Navigate to="/events" replace />;
	}

	return <Component />;
};
